import {FC, Card, PropsWithChildren, Button} from 'external/react'
import Icon from 'external/fortawesome'

import ButtonBack from 'components/ButtonBack'
import BasicLayout from './BasicLayout'

const AdminOffersContainer: FC<PropsWithChildren> = props => {
    const {children} = props
    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path='/admin' />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name='faBox' /> Ofertas
                </div>
                <div style={{ fontSize: '16px' }} className='d-flex flex-grow-1 justify-content-end align-items-center'>
                    <Button href='/admin/offers/configuration/create'>Crear Oferta</Button>
                </div>
            </Card.Header> 
            {children}
        </BasicLayout>
    )
}

export {AdminOffersContainer as default}